import { MeasurementsConfigSource } from "../@types"

export interface MeasurementsConfig {
  disallowedNetworks: number[]
}

export const createMeasurementsConfig: (
  source: MeasurementsConfigSource,
) => MeasurementsConfig = (s) => new MeasurementsConfigImpl(s)

class MeasurementsConfigImpl implements MeasurementsConfig {
  private _disallowedNetworks
  constructor(source: MeasurementsConfigSource) {
    /* eslint-disable @typescript-eslint/dot-notation */
    const disallow =
      source["geo"] && source["geo"]["asn"] && source["geo"]["asn"]["disallow"]
    /* eslint-enable @typescript-eslint/dot-notation */
    this._disallowedNetworks = disallow || []
  }
  get disallowedNetworks() {
    return this._disallowedNetworks
  }
}
